import { ActionButton } from '@/components/ZonesManagementRevamped/styles';
import { useFeatureFlag } from '@/hooks';
import * as state from '@/state';
import { Add, Close, Search } from '@mui/icons-material';
import { InputAdornment, Stack, TextField } from '@mui/material';
import { useState } from 'react';
import { useAtom, useAtomValue } from 'jotai';
import { AddStage } from '../../AddStage';
import { searchStyles } from './styles';

export const KanbanHeader = () => {
  const workflowStages = useAtomValue(state.workflowStages);
  const [searchTerm, setSearchTerm] = useAtom(state.searchedZone);
  const [addStage, setAddStage] = useState(false);
  const canAddStage = useFeatureFlag(['admin', 'ait-task-lead']) && workflowStages.length < 11;

  return (
    <Stack>
      <Stack direction="row" justifyContent="space-between" alignItems="center" marginTop="3.2rem">
        <TextField
          fullWidth
          data-testid="panel-search-input"
          size="small"
          sx={searchStyles}
          placeholder={'Search zones'}
          value={searchTerm}
          onChange={(event) => setSearchTerm(event.target.value)}
          slotProps={{
            input: {
              startAdornment: (
                <Search sx={{ fontSize: '2rem', color: '#6E8198', marginRight: '0.8rem' }} />
              ),
              endAdornment: searchTerm && searchTerm.length > 0 && (
                <InputAdornment position="end">
                  <Close
                    sx={{ cursor: 'pointer', fontSize: '1.6rem' }}
                    onClick={() => setSearchTerm('')}
                  />
                </InputAdornment>
              ),
            },
          }}
        />
        <Stack direction="row" alignItems="center" gap="2.4rem">
          {/* TODO: add the people filter here */}
          {canAddStage && (
            <ActionButton contained sx={{ padding: '0.6rem' }} onClick={() => setAddStage(true)}>
              <Add fontSize="small" />
              <span>Add stage</span>
            </ActionButton>
          )}
        </Stack>
      </Stack>
      {addStage && <AddStage isOpen={addStage} setIsOpen={setAddStage} />}
    </Stack>
  );
};
